import { Loader } from "lucide-react";
import { Button } from "src/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";
import { PricesData } from "../../../../../lib/languages";
import { useLanguage } from "../../../../../context/LanguageContext";

export default function DeletePriceDialog({
  isDeleteDialogOpen,
  setIsDeleteDialogOpen,
  selectedPrice,
  handleDeletePrice,
  btnLoading,
  resetForm,
  formatCurrency,
}) {
  const { language } = useLanguage();
  const strings = PricesData[language] || PricesData["en"];

  return (
    <Dialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
      <DialogContent
        className="sm:max-w-[425px]"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <DialogHeader>
          <DialogTitle>{strings.deletePriceTitle}</DialogTitle>
          <DialogDescription>{strings.deletePriceDesc}</DialogDescription>
        </DialogHeader>
        <div className="py-4">
          {selectedPrice && (
            <div className="rounded-lg border p-4">
              <h4 className="font-medium">{selectedPrice.name}</h4>
              <p className="text-sm text-muted-foreground">
                {formatCurrency(selectedPrice.price, selectedPrice.currency)}
                {selectedPrice.discount > 0 &&
                  ` (${selectedPrice.discount}% discount)`}
              </p>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              setIsDeleteDialogOpen(false);
              resetForm();
            }}
          >
            {strings.cancel}
          </Button>
          <Button
            variant="destructive"
            onClick={handleDeletePrice}
            disabled={btnLoading.delete}
          >
            {btnLoading.delete ? (
              <Loader className="animate-spin h-4 w-4" />
            ) : (
              strings.delete
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
